import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface MissingModuleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDemoMode?: () => void;
  shopLink: string;
}

const MissingModuleModal: React.FC<MissingModuleModalProps> = ({ isOpen, onClose, onDemoMode, shopLink }) => {
  const theme = useTheme();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          borderRadius: '1rem',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxSizing: 'border-box',
          boxShadow: 24,
          maxHeight: 'calc(100vh - 32px)',
          maxWidth: { xs: 'calc(100vw - 32px)', sm: 600 },
          minWidth: { xs: 0, sm: 300 },
          overflowY: 'auto',
          p: { xs: theme.spacing(2), sm: theme.spacing(4) },
          width: { xs: 'calc(100vw - 32px)', sm: 'auto' },
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing(2),
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={onClose} sx={{ color: theme.palette.grey[500] }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography variant="h5" component="h2">
          <FormattedMessage id="MissingModuleModal.titleFloorplannerMode" />
        </Typography>
        <Typography variant="body1">
          <FormattedMessage
            id="MissingModuleModal.description"
          />
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column-reverse', sm: 'row' },
            flexWrap: 'wrap',
            gap: theme.spacing(1.5),
            justifyContent: 'flex-end',
            '& .MuiButton-root': {
              width: { xs: '100%', sm: 'auto' },
            },
          }}
        >
          <Button
            variant="outlined"
            color="secondary"
            onClick={onDemoMode || onClose}
          >
            <FormattedMessage id="MissingModuleModal.demoModeButton" defaultMessage="Demo mode" />
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => window.open(shopLink, '_blank')}
          >
            <FormattedMessage id="MissingModuleModal.shopButton" />
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default MissingModuleModal;
